import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { environment } from '@szte-griffin/environment';
import { provideI18nScope } from '@pct-ng/transloco';
import { I18nProviderInjectionToken } from './i18n/i18n.scope';
import { TranslocoDirective } from '@jsverse/transloco';
import { fadeInEnter } from '@pct-ng/animation';

@Component({
  selector: 'szg-core-auth-ui-footer',
  templateUrl: './footer.component.html',
  animations: [fadeInEnter],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideI18nScope(I18nProviderInjectionToken)],
  host: {
    class: 'flex flex-col w-full gap-1 mt-4 text-center text-gray-300',
    '[@fadeInEnter]': '',
  },
  imports: [TranslocoDirective],
})
export class FooterComponent {
  protected readonly i18nScope = inject<string>(I18nProviderInjectionToken);

  protected readonly applicationName = environment.applicationName;
  protected readonly version = environment.version;
}
